import { render, staticRenderFns } from "./UpdateLecture.vue?vue&type=template&id=34e34c1f"
import script from "./UpdateLecture.vue?vue&type=script&lang=ts"
export * from "./UpdateLecture.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports